import { createContext, use, type ReactNode } from "react";

export interface FormPathContextValue {
  path: string;
}

const FormPathContext = createContext<FormPathContextValue>({
  path: "",
});

export const useFormPath = (): string => {
  const value = use(FormPathContext);
  return value.path;
};

export interface FormPathProviderProps {
  path: string;
  children: ReactNode;
}

export const FormPathProvider = ({ path, children }: FormPathProviderProps) => {
  return <FormPathContext value={{ path }}>{children}</FormPathContext>;
};
